// extracted by mini-css-extract-plugin
export var optionGrid = "_23-7";
export var optionList = "_23-6";
export var questionsBlock = "_23-9";
export var spacer = "_23-5";
export var stepCenteredContent = "_23-3";
export var stepInner = "_23-0";
export var stepInnerFullWidth = "_23-1";
export var stepInnerLockScroll = "_23-2";
export var stepTransitionFrame = "_23-4";
export var welcomeBlock = "_23-8";